'use strict';

/* jshint -W098 */
angular.module('mean.foreman').controller('ForemanCalendarController', ['$scope', 'Users', 'Global', 'Foreman', 'MeanUser', 'ProjectTasks', '$filter', 'Projects', 'ProjectBids', 'Builders', 'taskService', 'ngDialog', '$q', 'foremanCalendarService', 'userService', 'contactService', 'Trades', 'taskListService', 'tradeCodeService', 'aceUtils',
  function($scope, Users, Global, Foreman, MeanUser, ProjectTasks, $filter, Projects, ProjectBids, Builders, taskService, ngDialog, $q, foremanCalendarService, userService, contactService, Trades, taskListService, tradeCodeService, aceUtils) {
    $scope.global = Global;
    $scope.package = {
      name: 'foreman'
    };

    $scope.user = MeanUser.user;

    $scope.main_username = userService.getTradeCode($scope.user.username) +
        userService.getCompanyCode($scope.user.username) + '0000';

    $scope.showTasks = false;
    $scope.tasks = [];
    $scope.my_trade_code = tradeCodeService.getCode($scope.user.trade[0]);

    foremanCalendarService.setHolidaysArray($scope.user.username);

    $scope.admins = ['tm_office', 'tm_admin'];

    $scope.tradeAdmin = function(val) {
        return ($scope.admins.indexOf(val) !== -1);
    };
    $scope.init = function() {
        $scope.user.roles.forEach(function(role) {
            if($scope.tradeAdmin(role)) {
                $scope.is_admin = true;
            } else if (role === 'tm') {
                $scope.is_manager = true;
            } else if(role === 'foreman') {
                $scope.is_foreman = true;
            }
        });

        // $scope.$on('ngDialog.opened', function (e, $dialog) {
        //   $(".ngdialog").draggable({
        //     handle: ".ngdialog-content"
        //   });
        // });

        userService.getMainAccountId($scope.user.username).then(function(id) {
            contactService.getMyContacts(id).then(function(contacts) {
                $scope.builders = [];
                $scope.builders.push({
                    name: 'All',
                    company_code: 'All'
                });

                Trades.query({'main_account_id': id}, function(trade) {
                    $scope.companyFactors = trade[0].costs;
                    $scope.builders.push(trade[0]);
                });

                contacts.builders.forEach(function(builder) {
                    Builders.query({'builder': builder._id}, function(builders) {
                        $scope.builders.push(builders[0]);
                    });
                });
            });
        });

        taskListService.getByTrade($scope.my_trade_code).then(function(tasks) {
                $scope.tasks = $filter('orderBy')(tasks, 'task_code');
                var obj = {};
                obj.task_name = 'All';
                $scope.tasks.unshift(obj);
        });
    };

    var eventInfo = function(event) {
        $scope.event_start;
        $scope.event_end;
        if(event.allDay) {
            $scope.event_start = moment(event.start).add(1, 'days');
            $scope.event_end = moment($scope.event_start).clone().add(8, 'hours');
        } else {
            $scope.event_start = moment(event.start);
            $scope.event_end = moment(event.end).clone();
        }
        var newScope = $scope.$new();

        var builder, task_code, proj_id, phase, lot;
         if (aceUtils.isUndefinedOrNull($scope.selectedBuilder)) {
            builder = '';
        } else {
            if($scope.selectedBuilder.company_code === 'All') {
                builder = '';
            } else {
                if (aceUtils.isUndefinedOrNull($scope.selectedBuilder.main_account_id)) {
                    builder = $scope.selectedBuilder.builder.username;
                } else {
                    builder = $scope.selectedBuilder.main_account_id.username;
                }
            }
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedItem)) { 
            proj_id = '';
        } else {
            proj_id = $scope.selectedItem._id;
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedPhase)) { 
            phase = ''; 
        } else {
            phase = ($scope.selectedPhase.name === 'All') ? '' : $scope.selectedPhase.name;
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedLot)) { 
            lot = ''; 
        } else {
            if($scope.selectedLot.number === 'All') {
                lot = '';
            } else {
                lot = $scope.selectedLot.number;
                phase = $scope.selectedLot.phase;
            }
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedTask)) { 
            task_code = ''; 
        } else {
            task_code = ($scope.selectedTask.task_name === 'All') ? '' : $scope.selectedTask.task_code;
        }

        //have to grab a wider range of dates
        //so we can get tasks that span multiple days
        var task_start = moment($scope.event_start).clone().subtract(7, 'days');
        var task_end = moment($scope.event_end).clone().add(7, 'days');
        if($scope.is_admin) {
            if(!event.allDay) proj_id = event.project_id;
            taskService.getByTradeAndDateRange(builder, $scope.user.trade[0], 
                proj_id, phase, lot, task_code, $scope.main_username, task_start, 
                task_end, false).then(function(tasks) {
                //we need to find tasks that have multiple days and
                //divide them in to their own task entry
                var new_tasks = foremanCalendarService.separateTasks(tasks);

                foremanCalendarService.tasksForDialog(new_tasks, $scope.event_start).then(function(result) {
                    newScope.day_tasks = result;
                    newScope.cal_date = new Date($scope.event_start);
                    ngDialog.open({ 
                        template: 'foreman/views/foreman_calendar_dialog_template.html', 
                        scope: newScope, 
                        className: 'ngdialog-theme-default',
                        overlay: false,
                        closeByDocument: true
                    });
                });
            });
        } else if($scope.is_manager) {
            taskService.getByManagerIdAndDateRange($scope.user._id, builder,
                $scope.user.trade[0], proj_id, phase, lot, task_code, 
                task_start, task_end, false).then(function(tasks) {
                //we need to find tasks that have multiple days and
                //divide them in to their own task entry
                var new_tasks = foremanCalendarService.separateTasks(tasks);

                foremanCalendarService.tasksForDialog(new_tasks, $scope.event_start).then(function(result) {
                    newScope.day_tasks = result;
                    newScope.cal_date = new Date($scope.event_start);
                    ngDialog.open({ template: 'foreman/views/foreman_calendar_dialog_template.html', scope: newScope, className: 'ngdialog-theme-default'});
                });
            });
        } else if($scope.is_foreman) {
            taskService.getByForemanAndDateRange($scope.user.username, builder,
                $scope.user.trade[0], proj_id, phase, lot, task_code,
                task_start, task_end, false).then(function(tasks) {
                //we need to find tasks that have multiple days and
                //divide them in to their own task entry
                var new_tasks = foremanCalendarService.separateTasks(tasks);

                foremanCalendarService.tasksForDialog(new_tasks, $scope.event_start).then(function(result) {
                    newScope.day_tasks = result;
                    newScope.cal_date = new Date($scope.event_start);
                    ngDialog.open({ template: 'foreman/views/foreman_calendar_dialog_template.html', scope: newScope, className: 'ngdialog-theme-default'});
                });
            });
        }
    };

    var getEvents = function(start, end, timezone, callback) {
        $scope.events = [];

        var builder, task_code, proj_id, phase, lot;
        if (aceUtils.isUndefinedOrNull($scope.selectedBuilder)) {
            builder = '';
        } else {
            if($scope.selectedBuilder.company_code === 'All') {
                builder = '';
            } else {
                if (aceUtils.isUndefinedOrNull($scope.selectedBuilder.main_account_id)) {
                    builder = $scope.selectedBuilder.builder.username;
                } else {
                    builder = $scope.selectedBuilder.main_account_id.username;
                }
            }
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedItem)) {
            proj_id = ''; 
        } else {
            proj_id = ($scope.selectedItem.number === 'All') ? '' : $scope.selectedItem._id;
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedPhase)) { 
            phase = ''; 
        } else {
            phase = ($scope.selectedPhase.name === 'All') ? '' : $scope.selectedPhase.name;
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedLot)) { 
            lot = ''; 
        } else {
            if($scope.selectedLot.number === 'All') {
                lot = '';
            } else {
                lot = $scope.selectedLot.number;
                phase = $scope.selectedLot.phase;
            }
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedTask)) { 
            task_code = ''; 
        } else {
            task_code = ($scope.selectedTask.task_name === 'All') ? '' : $scope.selectedTask.task_code;
        }

        if($scope.is_builder) {

            //$scope.builderSelectionSet = callback;
        } else if($scope.is_admin) {
            taskService.getByTradeAndDateRange(builder, $scope.user.trade[0], 
                proj_id, phase, lot, task_code, $scope.main_username, start, end, 
                true).then(function(tasks) {
                if(tasks.length > 0)
                  $scope.events = foremanCalendarService.getEvents(tasks);
                callback($scope.events);
            });
        } else if($scope.is_manager) {
            taskService.getByManagerIdAndDateRange($scope.user._id, builder,
                $scope.user.trade[0], proj_id, phase, lot, task_code, 
                start, end, true).then(function(tasks) {
                if(tasks.length > 0)
                  $scope.events = foremanCalendarService.getEvents(tasks);
                callback($scope.events);
            });
        } else if($scope.is_foreman) {
            taskService.getByForemanAndDateRange($scope.user.username, builder,
                $scope.user.trade[0], proj_id, phase, lot, task_code, start, end, 
                true).then(function(tasks) {
                if(tasks.length > 0)
                  $scope.events = foremanCalendarService.getEvents(tasks);
                callback($scope.events);
            });
        }
    };

    console.log('calendar.js');

    $scope.uiConfig = {
      calendar:{
        editable: false,
        businessHours: true,
        header:{
          left: 'month basicWeek basicDay',
          center: 'title',
          right: 'today prev,next'
        },
        defaultView: 'month',
        dayClick: alertEventOnClick,
        eventClick: eventInfo,
        events: getEvents,
        loading: $scope.loading,
        eventRender: function(event, element) {
            if(typeof event.task_code !== 'undefined' &&
                typeof event.phase !== 'undefined') {
                element.find('.fc-title').append(
                    '<br/> Phase: ' + event.phaseStr + 
                    '<br/> Task: ' + event.taskStr + 
                    '<br/> Hours: ' + $filter('number')(event.hours, 2) + 
                    '<br/> Men Needed: ' + $filter('number')(event.hours/8, 2));
            } else {
                element.find('.fc-title').append(
                    '<br/> Hours: ' + $filter('number')(event.hours, 2) + 
                    '<br/> Men Needed: ' + $filter('number')(event.hours/8, 2));
            }
        }
      }
    };

    var alertEventOnClick = function(date, jsEvent, view) {
        console.log('dayClick event');
    };

    $scope.events = [];
    $scope.eventSources = [$scope.events];

    $scope.changeBuilder = function() {
        $scope.projects = [];
        $scope.phases = [];
        $scope.lots = [];
        $scope.showTasks = false;
        console.log('changeBuilder');

        userService.getMainAccount($scope.user.username).then(function(user) {
            var match_string = '{ "trades.main_username": ' + user.username + '}';
            if($scope.selectedBuilder.builder) {
                console.log('builder company code is ' + $scope.selectedBuilder.company_code);
                Projects.query({
                    'company_code': aceUtils.padDigits($scope.selectedBuilder.company_code,3),
                    'complete': false,
                    'trade_code': '00'}
                    , function(projects) {
                    $scope.projects = projects;

                    _.each($scope.projects, function(project) {
                        project.lots = _.remove(project.lots, function(lot) {
                            return !lot.complete;
                        });
                    });
                });
            } else {
                Projects.query({
                    'company_code': user.contractor_code,
                    'complete': false,
                    'trade_code': $scope.my_trade_code}
                    , function(projects) {
                    $scope.projects = projects;

                    _.each($scope.projects, function(project) {
                        project.lots = _.remove(project.lots, function(lot) {
                            return !lot.complete;
                        });
                    });
                });
            }
        });
    };

    $scope.changeProject = function() {
        $scope.lots = [];
        $scope.showTasks = false;

        if (aceUtils.isUndefinedOrNull($scope.selectedItem)) return;

        $scope.lots = $filter('orderBy')($scope.selectedItem.lots, ['number'], false);
        var obj = {};
        obj.number = 'All';
        $scope.lots.unshift(obj);

        $scope.phases = [];

        $scope.phases.push({
            name: 'All'
        });

        for(var i=0; i<$scope.selectedItem.lots.length; i++) {
            var inlist = $filter('filter')($scope.phases, { 
                'name': $scope.selectedItem.lots[i].phase}, true);

            if(inlist.length === 0)
                $scope.phases.push({
                    name: $scope.selectedItem.lots[i].phase
                });
        }
    };

    $scope.changePhase = function() {
        $scope.lots = [];

        if($scope.selectedPhase.name === 'All') {
            $scope.lots = $filter('orderBy')($scope.selectedItem.lots, ['number'], false);
        } else {
            var removed = $filter('filter')($scope.selectedItem.lots, {'phase': $scope.selectedPhase.name}, true);
            $scope.lots = $filter('orderBy')(removed, ['number'], false);
        }

        $scope.lots.unshift({
            number: 'All'
        });
    };

    $scope.changeLot = function() {
        if (aceUtils.isUndefinedOrNull($scope.selectedItem)) return;
        $scope.showTasks = true;
    };

    $scope.submit = function() {
        $scope.submitted = true;
        angular.element('#calendar').fullCalendar('refetchEvents');
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/foreman/public/controllers/calendar.js